import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { BenchmarkInsightSettingsModel } from 'lumen/routes/hotel/settings/competitors/benchmark';
import type { Transition } from 'lumen/services/transition';
import { BENI_COMPETITORS_TABS } from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

export default class HotelSettingsCompetitorsBenchmarkSmartCompsetRoute extends Route {
  queryParams = {};

  @service declare access: Services['access'];
  @service declare router: Services['router'];
  @service declare transition: Services['transition'];

  beforeModel(transition: Transition): void {
    if (!this.access.hasBenchmarkInsightSmartCompsetEdit) {
      this.transition.redirectToEnabledTab(transition);
    }

    // @ts-expect-error: Object is possibly 'null'.
    const { activeTab } = this.router.currentRoute.queryParams;

    if (!activeTab || activeTab !== BENI_COMPETITORS_TABS.SMART_COMPSET) {
      this.transition.validateBenchmarkInsightSmartCompsetBuilderQueryParams(
        transition,
      );
    }

    // Redirect to a subroute if the user lands on the index route, because the index route is just the empty modal component.
    if (
      transition.to?.name ===
      'hotel.settings.competitors.benchmark.smart-compset.index'
    ) {
      this.router.transitionTo(
        'hotel.settings.competitors.benchmark.smart-compset.categories',
      );
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  async deactivate(): Promise<void> {
    await this.model().then((res) => {
      const typedRes = res as BenchmarkInsightSettingsModel;
      typedRes.smartCompset.last?.value?.rollbackAttributes();
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/require-await
  async model() {
    return this.modelFor('hotel.settings.competitors.benchmark');
  }
}
